export default "__VITE_ASSET__BNXlGj8z__"